import { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../../config/firebaseConfig';

// Policies and JobDescriptions are assigned by role group, same as SOPs:
// a document is visible when its `group` contains the user's role or 'Hepsi'.
const fetchAssigned = async (collectionName, role) => {
  const ref = collection(db, collectionName);
  const [byRole, forAll] = await Promise.all([
    getDocs(query(ref, where('group', 'array-contains', role))),
    getDocs(query(ref, where('group', 'array-contains', 'Hepsi')))
  ]);
  const merged = new Map();
  [...byRole.docs, ...forAll.docs].forEach(d => merged.set(d.id, { id: d.id, ...d.data() }));
  return [...merged.values()];
};

const normalizePolicy = (p) => ({
  id: p.id,
  name: p.name || '',
  version: p.versionNumber,
  subtitle: p.category,
  description: p.description,
  fileUrl: p.fileUrl,
  fileName: p.fileName,
  fileType: p.fileType
});

const normalizeJobDescription = (j) => ({
  id: j.id,
  name: j.title || '',
  version: null,
  subtitle: j.position,
  description: j.description,
  fileUrl: j.fileUrl,
  fileName: j.fileName,
  fileType: j.fileType
});

const byName = (a, b) => a.name.localeCompare(b.name, 'tr');

const useAssignedDocuments = (role) => {
  const [policies, setPolicies] = useState([]);
  const [jobDescriptions, setJobDescriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!role) return undefined;
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const [policyDocs, jobDocs] = await Promise.all([
          fetchAssigned('Policies', role),
          fetchAssigned('JobDescriptions', role)
        ]);
        if (cancelled) return;
        setPolicies(policyDocs.map(normalizePolicy).sort(byName));
        setJobDescriptions(jobDocs.map(normalizeJobDescription).sort(byName));
      } catch (err) {
        console.error('Atanan politika/görev tanımları yüklenemedi:', err);
        if (!cancelled) setError('load');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [role]);

  return { policies, jobDescriptions, loading, error };
};

export default useAssignedDocuments;
